import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Mail, CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { useSearchParams, Link } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const u = params.get('u');
  const t = params.get('t');
  const [state, setState] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const doUnsub = async () => {
      if (!u || !t) {
        setState('error');
        setMessage('Lien invalide.');
        return;
      }
      try {
        const { data } = await axios.get(`${API}/api/unsubscribe`, { params: { u, t } });
        setState('success');
        setMessage(data.message || 'Vous êtes désinscrit.');
      } catch (e) {
        setState('error');
        setMessage(e?.response?.data?.detail || 'Une erreur est survenue.');
      }
    };
    doUnsub();
  }, [u, t]);

  return (
    <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center px-4" data-testid="unsubscribe-page">
      <div className="max-w-md w-full bg-neutral-900/70 border border-neutral-800 rounded-2xl p-8 text-center">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mb-4">
          {state === 'loading' && <Loader2 className="w-7 h-7 animate-spin text-emerald-400" />}
          {state === 'success' && <CheckCircle2 className="w-7 h-7 text-emerald-400" />}
          {state === 'error' && <XCircle className="w-7 h-7 text-red-400" />}
        </div>

        <div className="text-[10px] uppercase tracking-[4px] text-emerald-400 mb-1">TRADEX AI</div>
        <h1 className="text-xl font-bold mb-3">
          {state === 'loading' && 'Désinscription en cours…'}
          {state === 'success' && 'Désinscription confirmée'}
          {state === 'error' && 'Impossible de désinscrire'}
        </h1>
        <p className="text-sm text-neutral-400 leading-relaxed mb-6" data-testid="unsub-message">
          {message}
        </p>

        {state === 'success' && (
          <div className="text-xs text-neutral-500 mb-6 leading-relaxed">
            Vous ne recevrez plus d&apos;emails marketing.<br/>
            Les emails transactionnels (factures, sécurité) sont maintenus.
          </div>
        )}

        <Link to="/" className="inline-flex items-center gap-2 text-sm text-emerald-400 hover:text-emerald-300">
          <Mail className="w-4 h-4" /> Retour à TRADEX AI
        </Link>
      </div>
    </div>
  );
}
